export var NON_BREAKING_SPACE = '\xa0';
export class TextUtils {
  /**
   * Joins a list of strings with a comma, keeping the oxford comma and adding "and" as appropriate.
   * Eg.
   * One
   * One and Two
   * One, Two, and Three
   * @param items The items to join in a list
   * @param conjunction Conjunction to use between the last two items
   */
  static join(items) {
    var conjunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
    if (items == null || items.length === 0) {
      return '';
    }
    if (items.length === 1) {
      return items[0];
    }
    if (items.length === 2) {
      return "".concat(items[0], " ").concat(conjunction, " ").concat(items[1]);
    }
    var itemText = items.slice(0, items.length - 1).join(', ');
    var lastItem = items[items.length - 1];
    return "".concat(itemText, ", ").concat(conjunction, " ").concat(lastItem);
  }

  /**
   * Converts text to lower case, handling null if necessary and returning an empty string
   * @param text The text to convert to lower case
   * @param isNullAllowed True if a null string should return an empty string from this function. If false an error is thrown if null is passed in.
   */
  static toLower(text) {
    var isNullAllowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (text == null) {
      if (isNullAllowed) {
        return '';
      }
      throw new Error('Null string passed in to TextUtils.toLower');
    }
    return text.toLowerCase();
  }

  /**
   *
   * @param a The string to sort
   * @param b Second string to sort
   * @param isAscending Whether to sort ascending or descending
   */
  static sort(a, b) {
    var isAscending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (a < b) {
      return isAscending ? -1 : 1;
    }
    if (a > b) {
      return isAscending ? 1 : -1;
    }
    return 0;
  }

  /**
   * Pluralize a string based on a value
   * @param value The value to use for pluralization
   * @param singular The singular form of the string
   * @param pluralized The pluralized form of the string. If not provided, will append 's' to the singular form.
   * @returns The pluralized string
   */
  static pluralize(value, singular, pluralized) {
    if (value === 1) {
      return singular;
    }
    return pluralized !== null && pluralized !== void 0 ? pluralized : "".concat(singular, "s");
  }
}
export default TextUtils;
//# sourceMappingURL=TextUtils.js.map